(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-link"] && !Shopify.designMode) return;
  try {
    class CartLink extends HTMLElement {
    connectedCallback() {
      this.count = this.querySelector('[data-cart-count]');
      this.onCartUpdated = (event) => {
        const count = event.detail?.itemCount ?? event.detail?.item_count;
        if (typeof count === 'number') {
          this.render(count);
        } else {
          this.refresh();
        }
      };
      this.onPageShow = (event) => {
        if (event.persisted) this.refresh();
      };
      document.addEventListener('cart:updated', this.onCartUpdated);
      window.addEventListener('pageshow', this.onPageShow);
    }

    disconnectedCallback() {
      document.removeEventListener('cart:updated', this.onCartUpdated);
      window.removeEventListener('pageshow', this.onPageShow);
    }

    async refresh() {
      try {
        const root = window.Shopify?.routes?.root ?? '/';
        const response = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
        if (!response.ok) return;
        const cart = await response.json();
        this.render(cart.item_count);
      } catch (error) {
        // Keep the server-rendered state if the cart cannot be fetched.
      }
    }

    render(count) {
      this.classList.toggle('cart-link--full', count > 0);
      if (this.count) this.count.textContent = count > 0 ? `(${count})` : '';
    }
  }

  if (!customElements.get('cart-link')) {
    customElements.define('cart-link', CartLink);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cookie-banner"] && !Shopify.designMode) return;
  try {
    (() => {
    const banner = document.querySelector('[data-cookie-banner]');
    if (!banner || !window.Shopify || !window.Shopify.loadFeatures) return;

    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
      if (error) return;
      const privacy = window.Shopify.customerPrivacy;
      if (!privacy) return;
      // Shown to every visitor until they choose (and wherever Shopify requires consent)
      const consent = privacy.currentVisitorConsent ? privacy.currentVisitorConsent() : {};
      const undecided = ['analytics', 'marketing', 'preferences'].every((key) => !consent[key]);
      let remembered = null;
      try {
        remembered = localStorage.getItem('kb-cookie-choice');
      } catch (error) {
        remembered = null;
      }
      if (remembered && !privacy.shouldShowBanner()) return;
      if (!privacy.shouldShowBanner() && !undecided) return;
      banner.hidden = false;

      banner.addEventListener('click', (event) => {
        const button = event.target.closest('[data-cookie-choice]');
        if (!button) return;
        const accepted = button.dataset.cookieChoice === 'accept';
        try {
          localStorage.setItem('kb-cookie-choice', button.dataset.cookieChoice);
        } catch (error) {
          // Private mode: the banner may show again next visit
        }
        banner.hidden = true;
        privacy.setTrackingConsent(
          { analytics: accepted, marketing: accepted, preferences: accepted, sale_of_data: accepted },
          () => {
            banner.hidden = true;
          }
        );
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["experience"] && !Shopify.designMode) return;
  try {
    (() => {
    const root = document.documentElement;
    if (!root.classList.contains('reveal-on')) return;
    window.kbExperience = true;

    const LINES = [
      '.hero__heading > span',
      '.selected-works__heading > span',
      '.exhibitions__heading > span',
      '.awards__heading > span',
      '.listing__heading > span',
      '.commission__heading > span',
      '.text-page__heading > span',
      '.not-found__code',
    ].join(',');

    const FADES = [
      '.hero__statement',
      '.selected-works__intro',
      '.listing__intro',
      '.about__body',
      '.studio-quote__label',
      '.exhibition',
      '.award-row',
      '.not-found > :not(h1)',
    ].join(',');

    const PHOTOS = '.artwork-card, .listing-card__media';
    const PARALLAX = [
      ['.studio-quote__wings', -0.12],
      ['.feature-image__image', 0.12],
    ];

    const desktop = window.matchMedia('(min-width: 1024px)');
    const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');

    /* ---------- Smooth scrolling ---------- */
    let lenis = null;
    if (window.Lenis) {
      lenis = new window.Lenis({
        autoRaf: true,
        lerp: 0.09,
        anchors: true,
        prevent: (node) => Boolean(node.closest && node.closest('dialog, [data-lenis-prevent]')),
      });

      // The bag drawer and mobile menu lock the page by setting overflow on <html>
      const syncLock = () => {
        const locked = root.style.overflow === 'hidden' || root.classList.contains('menu-open');
        if (locked) lenis.stop();
        else if (!root.classList.contains('is-intro') || root.classList.contains('is-intro-done')) lenis.start();
      };
      new MutationObserver(syncLock).observe(root, { attributes: true, attributeFilter: ['style', 'class'] });
    }

    /* ---------- Reveals ---------- */
    const splitLine = (element) => {
      if (element.classList.contains('is-split')) return;
      const mask = document.createElement('span');
      const inner = document.createElement('span');
      mask.className = 'reveal-line';
      inner.className = 'reveal-line__inner';
      while (element.firstChild) inner.appendChild(element.firstChild);
      mask.appendChild(inner);
      element.appendChild(mask);
      element.classList.add('is-split');
    };

    const reveal = (elements) => {
      elements.forEach((element, index) => {
        element.style.setProperty('--reveal-delay', `${Math.min(index, 6) * 0.09}s`);
        element.classList.add('is-revealed');
      });
    };

    const observer =
      'IntersectionObserver' in window
        ? new IntersectionObserver(
            (entries) => {
              const visible = entries.filter((entry) => entry.isIntersecting).map((entry) => entry.target);
              visible.forEach((element) => observer.unobserve(element));
              reveal(visible);
            },
            { rootMargin: '0px 0px -8% 0px' }
          )
        : null;

    const scan = (scope) => {
      scope.querySelectorAll(LINES).forEach(splitLine);
      scope.querySelectorAll(`${LINES}, ${FADES}, ${PHOTOS}`).forEach((element) => {
        if (element.classList.contains('is-revealed')) return;
        if (observer) observer.observe(element);
        else element.classList.add('is-revealed');
      });
    };

    /* ---------- Parallax ---------- */
    const parallaxItems = [];
    const collectParallax = () => {
      parallaxItems.length = 0;
      for (const [selector, speed] of PARALLAX) {
        document.querySelectorAll(selector).forEach((element) => parallaxItems.push({ element, speed }));
      }
    };

    const updateParallax = () => {
      if (!desktop.matches) return;
      const middle = window.innerHeight / 2;
      for (const { element, speed } of parallaxItems) {
        // Measure the parent, which does not move, to avoid feedback
        const box = element.parentElement.getBoundingClientRect();
        if (box.bottom < -200 || box.top > window.innerHeight + 200) continue;
        const offset = (box.top + box.height / 2 - middle) * speed;
        element.style.translate = `0 ${offset.toFixed(1)}px`;
      }
    };

    if (lenis) lenis.on('scroll', updateParallax);
    else window.addEventListener('scroll', updateParallax, { passive: true });
    desktop.addEventListener('change', () => {
      if (!desktop.matches) parallaxItems.forEach(({ element }) => (element.style.translate = ''));
      else updateParallax();
    });

    /* ---------- Page transitions: the artwork photo flies to its page ---------- */
    let pendingArtwork = null;

    document.addEventListener('click', (event) => {
      const link = event.target.closest && event.target.closest('a[href]');
      if (!link) return;
      const card = link.closest('.artwork-card, .listing-card');
      pendingArtwork = null;
      if (!card) return;
      const image = [...card.querySelectorAll('.artwork-card__media img, .listing-card__media img')].find(
        (img) => img.offsetParent !== null
      );
      if (!image) return;
      pendingArtwork = image;
      try {
        sessionStorage.setItem('kb-vt-artwork', new URL(link.href, location.href).pathname);
      } catch (error) {}
    });

    window.addEventListener('pageswap', (event) => {
      if (!event.viewTransition) return;
      const header = document.querySelector('.site-header');
      if (header) header.style.viewTransitionName = 'site-header';
      if (pendingArtwork) pendingArtwork.style.viewTransitionName = 'artwork';
    });

    /* ---------- Cursor ---------- */
    const cursor = document.querySelector('[data-cursor]');
    if (cursor && finePointer.matches) {
      const dot = cursor.querySelector('[data-cursor-dot]');
      const ring = cursor.querySelector('[data-cursor-ring]');
      let x = -100;
      let y = -100;
      let ringX = x;
      let ringY = y;

      root.classList.add('has-cursor');

      window.addEventListener(
        'pointermove',
        (event) => {
          if (event.pointerType !== 'mouse') return;
          x = event.clientX;
          y = event.clientY;
          cursor.classList.add('is-visible');
        },
        { passive: true }
      );

      document.addEventListener('mouseleave', () => cursor.classList.remove('is-visible'));
      window.addEventListener('pointerdown', () => cursor.classList.add('is-down'));
      window.addEventListener('pointerup', () => cursor.classList.remove('is-down'));

      document.addEventListener('pointerover', (event) => {
        const target = event.target;
        if (!(target instanceof Element)) return;
        const typing = target.closest(
          'input:not([type="checkbox"], [type="radio"], [type="submit"]), textarea, [contenteditable]'
        );
        const view = target.closest('.artwork-card__media, .listing-card__media');
        const link = target.closest('a[href], button, label, summary, select, [role="button"]');
        cursor.classList.toggle('is-hidden', Boolean(typing));
        cursor.classList.toggle('is-view', Boolean(view));
        cursor.classList.toggle('is-link', Boolean(link) && !view);
      });

      const follow = () => {
        ringX += (x - ringX) * 0.18;
        ringY += (y - ringY) * 0.18;
        dot.style.transform = `translate3d(${x}px, ${y}px, 0)`;
        ring.style.transform = `translate3d(${ringX.toFixed(2)}px, ${ringY.toFixed(2)}px, 0)`;
        requestAnimationFrame(follow);
      };
      requestAnimationFrame(follow);
    }

    /* ---------- Start: after the intro on a first visit, right away otherwise ---------- */
    const start = () => {
      collectParallax();
      updateParallax();
      scan(document);
    };

    const intro = root.classList.contains('is-intro') ? document.querySelector('[data-intro]') : null;

    if (intro) {
      if (lenis) lenis.stop();
      const count = intro.querySelector('[data-intro-count]');
      const startedAt = performance.now();
      const duration = 1600;

      const finish = () => {
        try {
          sessionStorage.setItem('kb-intro', '1');
        } catch (error) {}
        root.classList.add('is-intro-done');
        if (lenis) lenis.start();
        setTimeout(start, 300);
        setTimeout(() => {
          intro.remove();
          root.classList.remove('is-intro', 'is-intro-done');
        }, 1300);
      };

      const tick = (now) => {
        const progress = Math.min(1, (now - startedAt) / duration);
        count.textContent = String(Math.round((1 - Math.pow(1 - progress, 3)) * 100));
        if (progress < 1) requestAnimationFrame(tick);
        else finish();
      };
      requestAnimationFrame(tick);
    } else {
      root.classList.remove('is-intro');
      start();
    }

    document.addEventListener('shopify:section:load', (event) => scan(event.target));
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["motion"] && !Shopify.designMode) return;
  try {
    (() => {
    const THRESHOLD = 0.2;
    const observed = new WeakSet();

    const observer =
      'IntersectionObserver' in window
        ? new IntersectionObserver(
            (entries) => {
              for (const entry of entries) {
                if (entry.isIntersecting && entry.intersectionRatio >= THRESHOLD) {
                  entry.target.classList.add('is-playing');
                  observer.unobserve(entry.target);
                }
              }
            },
            { threshold: THRESHOLD }
          )
        : null;

    const scan = (root) => {
      for (const element of root.querySelectorAll('[data-motion]')) {
        if (observed.has(element)) continue;
        observed.add(element);
        if (observer) {
          observer.observe(element);
        } else {
          element.classList.add('is-playing');
        }
      }
    };

    const start = () => scan(document);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }

    document.addEventListener('shopify:section:load', (event) => scan(event.target));
  })();
  } catch(e) { console.error(e); }
})();

})();
